// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3f-1";
export var movingGradient = "_3f-4";
export var movingGradientBlock = "_3f-2";
export var skeleton = "_3f-0";
export var skeletonText = "_3f-3";